<script>
export default {
  props: {
    success: {
      type: Number,
      required: true
    },
    missed: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    successPercentage() {
      return (this.success / this.total) * 100;
    },
    missedPercentage() {
      return (this.missed / this.total) * 100;
    }
  }
}
</script>

<template>

  <div class="progress-bar">
    <div class="success-section" :style="{ width: successPercentage + '%' }">{{success}}</div>
    <div class="missed-section" :style="{ width: missedPercentage + '%', left: successPercentage + '%' }">{{ missed }}</div>
    <div class="total-section">{{total}}</div>
  </div>

</template>

<style scoped>
.progress-bar {
  width: 100%;
  height: 15px;
  background-color: #dcdcdc;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  position: relative;
  font-size: 10px;
  font-weight: bold;
}

.success-section, .missed-section, .total-section {
  height: 100%;
  position: absolute;
  top: 0;
}

.success-section {
  background-color: #8BC34A;
}

.missed-section {
  background-color: #FFA500;
}

.total-section {
  background-color: transparent;
  color: #333;
  width: 100%;
  text-align: right;
  padding-right: 5px;
}
</style>
